import { API_URLS } from 'constants/apiUrls';
import { HttpClientRepository } from 'repositories/HttpClientRepository';
import { IAppFeatures } from './interfaces';

export default class AppFeaturesRepository {
    constructor(private readonly repository: HttpClientRepository) {}

    public fetchPartnerFeatures = (partnerCode: string) =>
        this.repository.get<IAppFeatures>(`${API_URLS.PARTNER_FEATURES}/${partnerCode}`, {
            local: true,
        });
}
